/*
 * Presentation-only seven-across weekday selector. Selection limits and
 * sessions-per-week reconciliation remain with the owning product surface.
 */
export default function WeekdaySelector({
  options = [],
  selectedValues = [],
  onToggle,
  maxSelected,
  disabled = false,
  ariaLabel = "Preferred training days",
}) {
  return (
    <div className="lz-product-weekdays" role="group" aria-label={ariaLabel}>
      {options.map((option) => {
        const isSelected = selectedValues.includes(option.value);
        const isDisabled =
          disabled ||
          (!isSelected &&
            typeof maxSelected === "number" &&
            selectedValues.length >= maxSelected);
        const initial = (option.shortLabel || option.label || "").charAt(0);

        return (
          <button
            key={option.value}
            type="button"
            className="lz-product-weekday"
            aria-label={option.label}
            aria-pressed={isSelected}
            disabled={isDisabled}
            onClick={() => onToggle(option.value)}
          >
            <span className="lz-product-weekday__initial" aria-hidden="true">
              {initial}
            </span>
          </button>
        );
      })}
    </div>
  );
}
